document.addEventListener('DOMContentLoaded',function() {

    function countdown(el, endDate) {
        let days, hours, minutes, seconds;

        endDate = new Date(endDate).getTime();

        if (isNaN(endDate)) {
            return;
        }

        let repeat_this = setInterval(calculate, 1000);
      
        function calculate() {
            let startDate = new Date();

            startDate = startDate.getTime();
            
            let timeRemaining = parseInt((endDate - startDate) / 1000);
            
            if (timeRemaining >= 0) {
                days = parseInt(timeRemaining / 86400);
                timeRemaining = (timeRemaining % 86400);
                
                hours = parseInt(timeRemaining / 3600);
                timeRemaining = (timeRemaining % 3600);
                
                minutes = parseInt(timeRemaining / 60);
                timeRemaining = (timeRemaining % 60);
                
                seconds = parseInt(timeRemaining);
                
                el.getElementsByClassName("days")[0].innerHTML = parseInt(days, 10);
                el.getElementsByClassName("hours")[0].innerHTML = ("0" + hours).slice(-2);
                el.getElementsByClassName("minutes")[0].innerHTML = ("0" + minutes).slice(-2);
                el.getElementsByClassName("seconds")[0].innerHTML = ("0" + seconds).slice(-2);
            } else {
                clearInterval(repeat_this);
                window.popup();
                document.querySelector('.js-timer').style.display = 'none';
                document.documentElement.classList.add('after-campaign');
                return;
            }
        };
    }
    
    const enableCounter = ()=> {
        document.querySelector('.js-timer').classList.remove('is-hidden');
    }

    var timeAt3pm = new Date("5/26/2023 00:00:00 AM").getTime()
      , timeNow = new Date().getTime()
      , offsetMillis = timeAt3pm - timeNow;
    setTimeout(enableCounter, offsetMillis);
    
    (function () { 
        const timer = document.getElementsByClassName('js-timer');
        
        if (timer.length > 0) {
            for (let i = 0; i < timer.length; i++) {
                let time = timer[i].getAttribute('data-endtime');
                countdown(timer[i], time);
            }
        } 
    }());

}, false)
